import Icon from '@/components/common/icons/Icon';
import { forwardRef } from '@chakra-ui/react';
import { ICON_BG_SIZES, IconName, IconSize } from '@common/react/icons';
import { IconButton, IconButtonProps } from './Button';

export interface SquareIconButtonProps
    extends Omit<IconButtonProps, 'size' | 'icon'> {
    size?: IconSize;
    iconName: IconName;
}

const SquareIconButton = forwardRef(
    (
        {
            size = 'sm',
            variant = 'outline',
            colorScheme = 'white',
            iconName,
            ...rest
        }: SquareIconButtonProps,
        ref
    ) => {
        const bgSize = ICON_BG_SIZES[size];

        return (
            <IconButton
                ref={ref}
                h={bgSize}
                minW={bgSize}
                w={bgSize}
                variant={variant}
                icon={<Icon name={iconName} size={size} />}
                colorScheme={colorScheme}
                rounded={6}
                {...rest}
            />
        );
    }
);

export default SquareIconButton;
